import { useState, useEffect } from "react";

export default function Langue() {
  const [language, setLanguage] = useState("fr");

  // Effet pour appliquer la langue sélectionnée
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return (
    <div className="p-6">
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Paramètres de langue</h3>

      {/* Sélecteur de langue */}
      <div className="mt-4">
        <label className="text-gray-700 dark:text-gray-300">Choisissez votre langue</label>
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          className="w-full mt-2 p-2 border rounded-lg bg-white dark:bg-gray-700 dark:text-white"
        >
          <option value="fr">🇫🇷 Français</option>
          <option value="en">🇬🇧 Anglais</option>
          <option value="es">🇪🇸 Espagnol</option>
          <option value="de">🇩🇪 Allemand</option>
          <option value="it">🇮🇹 Italien</option>
          <option value="pt">🇵🇹 Portugais</option>
        </select>
      </div>

      {/* Affichage de la langue sélectionnée */}
      <p className="mt-4 text-gray-700 dark:text-gray-300">
        Langue actuelle : <span className="font-semibold">{language.toUpperCase()}</span>
      </p>
    </div>
  );
}
